import React from "react";
import { IconButton } from "material-ui";
import ReactTooltip from 'react-tooltip';
import ActionHelp from 'material-ui/svg-icons/action/help';
import * as util from "../../util";

class CheckoutOrderSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hovered: false,
      width: 0,
      height: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  getStyles() {
    return {
      summaryTable: {
        width: "100%", 
        borderCollapse: "collapse", 
        fontSize: "0.9em"
      },
      summarySpacerRow: {
        height: 8
      },
      summaryHeader: {
        textAlign: "left"
      },
      summaryItemRow: {
        paddingBottom: 8
      },
      summaryItemColumnLeft: {
        textAlign: "left", 
        verticalAlign: "bottom", 
        padding: "0px 8px 0px 0px"
      },
      summaryItemColumnRight: {
        textAlign: "right", 
        verticalAlign: "bottom", 
        padding: "8px 0px 0px 0px"
      },
      summarySubtotalRow: { 
        paddingBottom: 0, 
        borderTop: "1px solid #333"
      },
      summarySubtotalColumnLeft: { 
        textAlign: "left", 
        padding: "8px 8px 0px 0px" 
      },
      summarySubtotalColumnRight: { 
        textAlign: "right", 
        padding: "8px 0px 0px 0px"
      },
      summaryServiceFeeRow: { 
        paddingBottom: 0, 
        borderBottom: "1px solid #333" 
      },
      summaryServiceFeeColumnLeft: {
        textAlign: "left", 
        padding: "0px 8px 8px 0px",
        verticalAlign: "bottom", 
      },
      summaryServiceFeeColumnRight: {
        textAlign: "right", 
        padding: "0px 0px 8px 0px",
        verticalAlign: "bottom", 
      },
      summaryTotalRow: { 
        fontWeight: "bold"
      },
      summaryTotalColumnLeft: { 
        textAlign: "left", 
        padding: "8px 8px 8px 0px"
      },
      summaryTotalColumnRight: { 
        textAlign: "right", 
        padding: "8px 0px 8px 0px"
      },
      summaryTooltipIconButton: {
        border: 0, 
        marginLeft: 3, 
        padding: 0, 
        width: 18, 
        height: 18 
      },
      summaryTooltipIconImage: {
        color: "#ccc", 
        width: 18, 
        height: 18, 
        padding: 0
      }
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {

    let styles = this.getStyles();

    let subtotal = 0, serviceFee = 0, centsOff = 0;
    this.props.order.subitem_prices.map(sp => {
      subtotal = subtotal + sp.total - sp.fee;
      serviceFee = serviceFee + sp.fee;
      if (sp.cents_off) {
        centsOff = centsOff + sp.cents_off;
      }
    });

    let total = subtotal + serviceFee;

    // if a pass is used and the total is 0, show this simplified summary
    if (total === 0 && this.props.order.pass && this.props.useSundanceModals) {
      return (
        <div style={{ ...this.props.styles, backgroundColor: "#e9e9e9" }}>
          <table style={{ ...styles.summaryTable, backgroundColor: "#e9e9e9" }}>
            <tr>     
              <td colSpan="2" style={styles.summaryHeader}>
                <h2>Order Summary</h2>
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                The total price of this order is $0. You will not be charged.
              </td>
            </tr>
          </table>
        </div>
      )
    }

    return (
      <div style={this.props.styles}>
        <table style={styles.summaryTable}>
          <tr>     
            <td colSpan="2" style={styles.summaryHeader}>
              <h2>Order Summary</h2>
            </td>
          </tr>
          {this.props.order.coupon ? (
            <tr style={styles.summaryItemRow}>
              <td style={styles.summaryItemColumnLeft} colSpan="2" >
                <b>Discount:</b> <i>{this.props.order.coupon.name}</i>
              </td>
            </tr>
          ) : null}
          {this.props.order.subitem_prices.map((item) => 
            item.inline_donation ? (
              <tr style={styles.summaryItemRow}>
                <td style={styles.summaryItemColumnLeft}>
                  <div>
                    {item.name} x{item.quantity}
                    <IconButton iconStyle={styles.summaryTooltipIconImage} style={styles.summaryTooltipIconButton} data-for="iconbutton-donation-tooltip" data-tip="Click the $0 button to remove the donation amount.">
                      <ActionHelp />
                    </IconButton>
                    <ReactTooltip
                      id="iconbutton-donation-tooltip"
                      style={{ maxWidth: "70vw" }}
                      place={this.state.width > 825 ? "top" : "right"}
                      overridePosition={({ left, top }, currentEvent) => {
                        const targetNode = currentEvent.getBoundingClientRect ? currentEvent : currentEvent.target;
                        let targetNodeTopVal = {};
                        if (targetNode && targetNode.getBoundingClientRect) {
                          targetNodeTopVal = targetNode.getBoundingClientRect();
                        }
                        const { top: targetNodeTop } = targetNodeTopVal;
                        return { left, top: targetNodeTop || top };
                      }}
                    />
                  </div>
                </td>
                <td style={styles.summaryItemColumnRight}>
                  {util.formatPrice((item.price * item.quantity), true, true)}   
                </td>
              </tr>
            ) : (
              <tr style={styles.summaryItemRow}>
                <td style={styles.summaryItemColumnLeft}>{item.name} x{item.quantity}</td>
                <td style={styles.summaryItemColumnRight}>{util.formatPrice((item.price * item.quantity), true, true)}</td>
              </tr>
            )
          )}
          {this.props.order.coupon && centsOff ? (
            <tr style={styles.summaryItemRow}>
              <td style={styles.summaryItemColumnLeft}><i>Discount Applied</i></td>
              <td style={styles.summaryItemColumnRight}>-{util.formatPrice(centsOff, true, true)}</td>
            </tr>
          ) : null}
          <tr style={styles.summarySpacerRow}><td colspan="2"></td></tr>
          <tr style={styles.summarySubtotalRow}>
            <td style={styles.summarySubtotalColumnLeft}>Subtotal</td>
            <td style={styles.summarySubtotalColumnRight}>
              {util.formatPrice(subtotal, true, true)}
            </td>
          </tr>
          <tr style={styles.summaryServiceFeeRow}>
            <td style={styles.summaryServiceFeeColumnLeft}>
              <div>
                Service Fee 
                <IconButton iconStyle={styles.summaryTooltipIconImage} style={styles.summaryTooltipIconButton} data-for="iconbutton-servicefee-tooltip" data-tip="There is a service fee of 3.5% plus 35¢ per ticket.">
                  <ActionHelp />
                </IconButton>
                <ReactTooltip
                  id="iconbutton-servicefee-tooltip"
                  style={{ maxWidth: "70vw" }}
                  place={this.state.width > 825 ? "top" : "right"}
                  overridePosition={({ left, top }, currentEvent) => {
                    const targetNode = currentEvent.getBoundingClientRect ? currentEvent : currentEvent.target;
                    let targetNodeTopVal = {};
                    if (targetNode && targetNode.getBoundingClientRect) {
                      targetNodeTopVal = targetNode.getBoundingClientRect();
                    }
                    const { top: targetNodeTop } = targetNodeTopVal;
                    return { left, top: targetNodeTop || top };
                  }}
                />
              </div>
            </td>
            <td style={styles.summaryServiceFeeColumnRight}>
              {util.formatPrice(serviceFee, true, true)}       
            </td>
          </tr>      
          <tr style={styles.summaryTotalRow}>
            <td style={styles.summaryTotalColumnLeft}>Total</td>
            <td style={styles.summaryTotalColumnRight}>
              {util.formatPrice(total, true, true)}
            </td>
          </tr>
        </table>
      </div>
    );
  }
}

export default CheckoutOrderSummary;



// WEBPACK FOOTER //
// ./src/app/components/partials/checkout-order-summary.jsx